import {defineMessages} from 'react-intl';

const genericMessages = defineMessages({
  error: {
    id: 'ErrorPanel.genericMessages.error',
    defaultMessage: 'Error type: {errorCode}',
  },
});

const defaultMessages = defineMessages({
  buttonRedirect: {
    id: 'ErrorPanel.defaultMessages.buttonRedirect',
    defaultMessage: 'Let\'s get out of here',
  },
  buttonRefresh: {
    id: 'ErrorPanel.defaultMessages.buttonRefresh',
    defaultMessage: 'Let\'s refresh',
  },
  header: {
    id: 'ErrorPanel.defaultMessages.header',
    defaultMessage: 'Whoops',
  },
  subheader: {
    id: 'ErrorPanel.defaultMessages.subheader',
    defaultMessage: 'This is not right',
  },
  paragraph: {
    id: 'ErrorPanel.defaultMessages.paragraph',
    defaultMessage: 'It seems something went wrong.{linebreak}Please try again or come back later.{errorType}',
  },
});

export {defaultMessages, genericMessages};
